module.exports = __webpack_public_path__ + "img/circle-shape1.01ae53ca.png";